import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";


 
 
 
export default function GPSStandard({
  gps
}: {
    gps: any
}) {
  const { t } = useTranslation();
 
  const headerTemplatePendencia = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {gps.PEND_FINANCEIRAS && gps.PEND_FINANCEIRAS.OCORRENCIAS && gps.PEND_FINANCEIRAS.OCORRENCIAS.length > 0 ? (<div><span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendencia')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendencia')}</span>) }</div>;
  }


 
  
  return (
    <div>
    {gps.mensagemErro ? (<p>{gps.mensagemErro}</p>) :
    (<div>
     
        
    <Panel headerTemplate={headerTemplatePendencia}>
        {!gps.PEND_FINANCEIRAS || !gps.PEND_FINANCEIRAS.OCORRENCIAS || gps.PEND_FINANCEIRAS.OCORRENCIAS.length === 0 ? ( <NadaConsta />) : (<>
        <DataTable size="small" value={gps.PEND_FINANCEIRAS.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA_INCLUSAO" header={t('data')}></Column>
            <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
            <Column field="CONTRATO" header={t('contrato')}></Column>
            <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
            <Column field="CREDOR" header={t('informante')}></Column>
            <Column field="VALOR" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    <br></br>

    </div>)}
  </div>
  )
}
